'use strict';
var $ = require('jquery');
require('bootstrap-datepicker');
var startDatesService = require('./services/startDatesService');
var errorByKey = require('./forms/validation').errorByKey;
var assertExists = require('./utils/asserts').assertExists;
var dateUtils = require('./utils/dateUtils');

module.exports = function StartDatePicker(config) {
    assertExists(config.id, "Missing property id - mandatory value");
    assertExists(config.mountOn, "Missing  property mountOn - where this component should be rendered?");

    if (config.mountImmediateley) {
        doRender();
    }
    registerValidationMethods();

    var startDateData;

    return {
        render: render,
        renderSingleDate: renderSingleDate,
        setValue: setValue
    };

    function render(employeeGroupId, productType) {
        return startDatesService.getPolicyStartDate(employeeGroupId, productType)
            .then(function (data) {
                startDateData = data;
                renderProductDates(startDateData);
                return {
                    setValue: setValue,
                    getStartDateData: function () {
                        return startDateData;
                    }
                };
            });
    }

    function setValue(value) {
        $('#'+config.id).val(value);
    }

    function doRender(data) {
        var supportText1i18nPostfix, supportText2i18nPostfix;
        if(config.supportTexti18nPostfix instanceof Function) {
            supportText1i18nPostfix = config.supportTexti18nPostfix(data, 1);
            supportText2i18nPostfix = config.supportTexti18nPostfix(data, 2);
        }
        var props = {
            id: config.id,
            mountOn: config.mountOn,
            inputName: config.inputName,
            i18nContext: config.i18nContext,
            supportText1i18nPostfix: supportText1i18nPostfix,
            supportText2i18nPostfix: supportText2i18nPostfix
        };
        $('#'+config.mountOn).replaceWith(require('shared/jade/templates/startDatePicker.jade')(props));
        $('#'+config.mountOn).localize();
        if (config.onChange) {
            $('#' + config.id).change(function (event) {
                config.onChange(event.target.value);
            });
        }
    }

    function renderProductDates(data) {
        if (!config.mountImmediateley) {
            doRender(data);
        }
        var startDate = data.minStartDate ? getDaysFromNow(data.minStartDate) : "-14d";
        var endDate = data.maxStartDate ? "+" + getDaysFromNow(data.maxStartDate) : "+30d";
        var input = $('#'+config.id);
        var element = document.getElementById(config.id); 
        element.minStartDate = data.minStartDate;
        element.maxStartDate = data.maxStartDate;
        element.excludedDates = data.excludedDates;

        $('.input-group.date').datepicker({
            format: "dd/mm/yyyy",
            container: '.input-group.date',
            autoclose: true,
            startDate: startDate,
            endDate: endDate,
            datesDisabled: data.excludedDates
        }).on('show', function () {
            var element = $('.datepicker.datepicker-dropdown.dropdown-menu');
            var requiredHeight = element.offset().top + element.outerHeight();
            var offset = requiredHeight - window.innerHeight;
            if (requiredHeight > window.innerHeight) {
                $('html,body').animate({scrollTop: offset}, 100);
            }
        });

        input.prop('disabled', false);
        $('#'+config.mountOn).show();

        $('.datepicker-cover-mobile').click(function () {
            $(this).parent('.date').datepicker('show');
        });

        var supportTextStyleClass;
        if(config.supportTextStyleClass instanceof Function) {
            supportTextStyleClass = config.supportTextStyleClass(data);
        }
        if (config.supportTextVisible instanceof Function) {
            var supportTextEval = config.supportTextVisible($.extend(true, {}, data));
            toggleSupportText(supportTextEval, supportTextStyleClass);
        } else {
            toggleSupportText((config.supportTextVisible === true), supportTextStyleClass);
        }
    }

    function toggleSupportText(flag, styleClass) {
        var supportText = $('#'+config.mountOn +' .policy-start-date-support-text');
        if (flag) {
            if(styleClass) {
                supportText.addClass(styleClass);
            }
            supportText.show();
        } else {
            supportText.hide();
        }
    }

    function renderSingleDate(renewalDateString) {
        var min = datePlusMinusOneDay(new Date(renewalDateString), false);
        min = dateUtils.dateFormatDayMonthYear(min);
        var minString = min.toLocaleString();
        var max = datePlusMinusOneDay(new Date(renewalDateString), true);
        max = dateUtils.dateFormatDayMonthYear(max);
        var maxString = max.toLocaleString();

        startDateData = {
            excludedDates: [],
            maxStartDate: maxString,
            minStartDate: minString,
            renewalDateInStartDateWindow: false
        };
        renderProductDates(startDateData);
        return {
            setValue: setValue,
            getStartDateData: function () {
                return startDateData;
            }
        };
    }
};

function registerValidationMethods() {
    $.validator.addMethod("dateRangeValidator", function(value, element) {
        if (/^\d{2}\/\d{2}\/\d{4}$/.test(value)) {
            if (dateUtils.dateIsBetween(element.minStartDate, element.maxStartDate, value)) {
                //valid so far, check if exlucedDates have config
                if (element.excludedDates) {
                    return element.excludedDates.every(function(date) {
                        return !dateUtils.isSameDate(date, value);
                    });
                }
                return true;
            }
        }
        return false;
    }, errorByKey("policy.start.date.range.Invalid"));
}

function getDaysFromNow(date) {
    return dateUtils.getDaysFromNow(date) + 'd';
}

function datePlusMinusOneDay(date, plus){
    if(plus) {
        date.setDate(date.getDate()+1);
    } else {
        date.setDate(date.getDate()-1);
    }
    return date;
}



//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/StartDatePicker.js
// module id = P32B
// module chunks = 2